import {
  useTrustpilotAverageRating,
  useTrustpilotReviewCount,
  type TrustpilotDisplayData,
} from "@made-people/grease-trustpilot";
import { StarRating } from "./trustpilot-shared";

export const ProductReviewsSneakpeek = ({
  reviewsData,
}: {
  reviewsData?: TrustpilotDisplayData | null;
}) => {
  const contextAverageRating = useTrustpilotAverageRating("product");
  const contextTotalReviews = useTrustpilotReviewCount("product");

  const averageRating = reviewsData?.averageRating ?? contextAverageRating;
  const totalReviews = reviewsData?.totalReviews ?? contextTotalReviews;

  if (totalReviews === 0) {
    return null;
  }

  const scrollToProductReviews = () => {
    const element = document.getElementById("product-reviews");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <div className="flex items-center gap-2">
      <StarRating
        rating={averageRating}
        className="gap-1"
        starClassName="h-4 w-4"
      />
      <button
        onClick={scrollToProductReviews}
        className="text-sm underline cursor-pointer underline-offset-4"
      >
        ({totalReviews})
      </button>
    </div>
  );
};
